import { useMemo } from "react";
import { useAuthContext } from "providers/Auth";
import { User } from "views/settings-users/types";

export const useSortedAssignees = (assignees: User[] | undefined) => {
  const { auth } = useAuthContext();

  return useMemo(() => {
    if (!assignees) return [];
    const sorted = assignees.toSorted((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });
    if (auth) {
      const withoutAuth = sorted.filter((a) => a.id !== auth.id);
      return [auth, ...withoutAuth];
    }
    return sorted;
  }, [assignees, auth]);
};
